// Camera barcode scanning runs in the page itself (Safari, Chrome, and the Eadin app's
// web view), so the same code is used everywhere. It needs a secure (https) page.
export const webCameraAvailable = () => typeof window !== 'undefined'
  && Boolean(window.isSecureContext)
  && typeof navigator !== 'undefined'
  && typeof navigator.mediaDevices?.getUserMedia === 'function';

// Product labels use UPC/EAN or Code 128 (e.g. DFL-MLUX prints 810101322006 as Code 128);
// location labels are Code 128, Code 39 or QR. Names are zxing-wasm format names.
export const CAMERA_FORMATS = ['UPCA', 'UPCE', 'EAN13', 'EAN8', 'Code128', 'Code39', 'QRCode'];

// Full-HD frames: thin product barcodes need the extra pixels to read from arm's length.
export const CAMERA_VIDEO = { facingMode: { ideal: 'environment' }, width: { ideal: 1920 }, height: { ideal: 1080 } };

// A 12-digit UPC-A can be reported as a 13-digit EAN-13 with a leading 0.
export const normalizeCameraCode = (read) => {
  const value = String(read?.value || '').trim();
  if (read?.format === 'EAN13' && /^0\d{12}$/.test(value)) return value.slice(1);
  return value;
};

export const cameraErrorCode = (err) => {
  if (['NotAllowedError', 'SecurityError', 'PermissionDeniedError'].includes(err?.name)) return 'denied';
  return 'unavailable';
};

export const CAMERA_MESSAGES = {
  denied: 'Camera access is off. Type the code or use the Socket scanner. To turn the camera on, allow it for this site (iPhone/iPad: Settings > Apps > Safari > Camera) or for the Eadin app in Settings.',
  unavailable: 'The camera isn\'t available here. Type the code or use the Socket scanner.',
};
